/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/require-computed-property-dependencies */
import { computed, get } from '@ember/object';
import { readOnly, map } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Predicate from 'predicates/models/predicate';
import { readsAndFmtWithProperty } from '@intercom/pulse/lib/computed-properties';
import { IOS_DEVICES } from 'predicates/models/data/ios';
export default Predicate.extend({
  appService: service(),
  userSegments: readOnly('appService.app.editableUserSegments'),
  companySegments: readOnly('appService.app.editableCompanySegments'),
  tags: readOnly('appService.app.tags'),
  subscriptionTypes: readOnly('appService.app.subscriptionTypes'),
  androidDevices: readOnly('appService.app.android_devices'),
  genericType: 'select',
  isEditable: true,
  isSelectType: true,
  defaultComparison: 'in',
  goalComparison: 'in',
  getDefaultValue() {
    return this.get('options.firstObject.value');
  },
  options: readsAndFmtWithProperty('%@Options', 'camelizedType'),
  tagOptions: computed('userSegments.[]', function () {
    return this.userSegments.map(segment => ({
      label: get(segment, 'name'),
      value: get(segment, 'id')
    }));
  }),
  companyTagOptions: computed('companySegments.[]', function () {
    return this.companySegments.map(segment => ({
      label: get(segment, 'name'),
      value: get(segment, 'id')
    }));
  }),
  manualTagOptions: computed('tags.[]', 'value', function () {
    let app = this.appService.app;
    let tags = app.tags.reject(tag => tag.archived && tag.id.toString() !== this.value.toString());
    return tags.map(tag => ({
      label: get(tag, 'name'),
      value: get(tag, 'id')
    }));
  }),
  subscriptionTypeOptions: computed('subscriptionTypes.[]', 'value', function () {
    let app = this.appService.app;
    let subscriptionTypes = app.subscriptionTypes.reject(subscriptionType => subscriptionType.isDraft);
    return subscriptionTypes.map(subscriptionType => ({
      label: subscriptionType?.translationForTeammate?.name,
      value: subscriptionType?.id
    }));
  }),
  iosDeviceOptions: IOS_DEVICES,
  androidDeviceOptions: map('androidDevices', function (device) {
    return {
      label: device,
      value: device
    };
  }),
  phoneCountryOptions: ['US', 'CA', 'GB'],
  selectedTag: computed('tags.[]', 'value', function name(params) {
    return this.tags.findBy('id', this.value);
  }),
  isProcessing: computed('selectedTag.status', function () {
    return !!this.selectedTag?.isProcessing;
  }),
  processingTooltipContent: computed('selectedTag.status', function () {
    return this.selectedTag?.processingText ?? '';
  }),
  selectedTagFailed: computed('selectedTag.status', function () {
    return !!this.selectedTag?.isFailed;
  })
});